import {Route} from '@angular/router';

import {DocsComponent} from '@app/admin/docs/docs.component';

export const docsRoute: Route = {
  path: 'docs',
  component: DocsComponent,
  data: {
    pageTitle: 'admin.docs.API_title',
  },
};
